import { gql } from '@apollo/client';

export const DASHBOARD_QUERY = gql`
  query GetDashboard($input: DashboardInput!) {
    getDashboard(input: $input) {
      stats {
        totalUsers
        totalRoadsFinished
      }
      stats2 {
        totalRoadsConsume
        totalRoadsLikes
        totalRoadsShare
      }
      stats3 {
        totalNewsUsers
        totalRecurrentUsers
        session {
          labels
          datasets {
            data
            name
          }
        }
        clients {
          datasets {
            name
            data
          }
          labels
        }
      }
      stats4 {
        totalGenderTop {
          data
          name
        }
        genders {
          datasets {
            data
            name
          }
          labels
        }
        dailyRegister {
          datasets {
            name
            data
          }
          labels
        }
      }
      stats5 {
        totalRoadsByPillars {
          _id
          amount
          title
        }
        totalRoadsLikesByPillars {
          _id
          amount
          title
        }
      }
    }
  }
`;
